import styled from "styled-components";
import Input from "./Input";
import TextArea from "./TextArea";
import DatePicker from "./DatePickerInput";
import React from "react";
import { colors } from "../colors";

export const Space = styled.div`
  margin: 16px;
`;

export const InfoWrapper = styled.p`
  padding: 16px;
  border-radius: 4px;
  border-left: 5px solid ${colors.brightBlue};
  background-color: rgba(0, 123, 255, 0.05);
  font-size: 14px;
  color: ${colors.slateGrey};
  margin: 0 0 16px 0;
`;

export const WarningWrapper = styled.p`
  padding: 16px;
  border-radius: 4px;
  border-left: 5px solid ${colors.darkMustard};
  background-color: ${colors.lightTan};
  font-size: 14px;
  color: ${colors.darkMustard};
  margin: 0 0 16px 0;
`;

export { Loader } from "./UpkeepLoaderTripleGear";

export const TextInput = props => <Input type="text" {...props}/>;
export const NumberInput = props => <Input type="number" {...props}/>;

export const DateInput = props => <DatePicker {...props}/>;
export const TextAreaInput = props => <TextArea {...props}/>;

export { Checkbox as CheckboxInput } from "./Checkbox";
export { FileInput } from "./FileInput";
export { EmailInput } from "./EmailInput";

export { CostInput } from './CostInput';
export { TaxInput } from './TaxInput';
export { SelectLocation } from './SelectLocation';
export { SelectAsset } from './SelectAsset';
export { SelectPart } from './SelectPart';
export { SelectCategory } from './SelectCategory';
export { SelectUser } from './SelectUser';
export { SelectTeam } from './SelectTeam';
export { SelectVendor } from './SelectVendor';

export { Button } from "./Button";
